import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { BreadCrumbsComponent } from '../../../../Shared/components/bread-crumbs/bread-crumbs.component';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { RouterLink } from '@angular/router';
import { ContactUsFormComponent } from '../../components/contact-us-form/contact-us-form.component';
import { isPlatformBrowser } from '@angular/common';
import { TranslatePipe, TranslateService} from '@ngx-translate/core';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';
import { TimelineStepsComponent, TimelineStep } from '../../../../Shared/components/timeline-steps/timeline-steps.component';

import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-join-as-professional',
        standalone: true,
imports: [BreadCrumbsComponent, ContactUsFormComponent, TimelineStepsComponent
    ],
    templateUrl: './join-as-professional.component.html',
    styleUrl: './join-as-professional.component.scss'
})
export class JoinAsProfessionalComponent {
  breadcrumbItems: Breadcrumb[] = [];

  timelineSteps: TimelineStep[] = [
    {
      number: 1,
      titleKey: 'join_as_professional.join_as_professional_timeline_step_1_title',
      descriptionKey: 'join_as_professional.join_as_professional_timeline_step_1_desc',
      link: environment?.horseOwnerPortalUrl
    },
    {
      number: 2,
      titleKey: 'join_as_professional.join_as_professional_timeline_step_2_title',
      descriptionKey: 'join_as_professional.join_as_professional_timeline_step_2_desc'
    },
    {
      number: 3,
      titleKey: 'join_as_professional.join_as_professional_timeline_step_3_title',
      descriptionKey: 'join_as_professional.join_as_professional_timeline_step_3_desc'
    },
    {
      number: 4,
      titleKey: 'join_as_professional.join_as_professional_timeline_step_4_title',
      descriptionKey: 'join_as_professional.join_as_professional_timeline_step_4_desc'
    },
    {
      number: 5,
      titleKey: 'join_as_professional.join_as_professional_timeline_step_5_title',
      descriptionKey: 'join_as_professional.join_as_professional_timeline_step_5_desc'
    },
    {
      number: 6,
      titleKey: 'join_as_professional.join_as_professional_timeline_step_6_title',
      descriptionKey: 'join_as_professional.join_as_professional_timeline_step_6_desc'
    }
  ];

  currentLang: any;

  isBrowser: boolean;

  wordpressUrl = environment?.wordpressUrl;
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private translate: TranslateService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
    }
  }
}
